import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';

@Component({
  selector: 'app-common-date-picker',
  standalone: true,
  imports: [CommonModule, FormsModule, CalendarModule],
  templateUrl: './common-date-picker.component.html',
  styleUrls: ['./common-date-picker.component.scss']
})
export class CommonDatePickerComponent {
  /** Controls visibility */
  @Input() show: boolean = false;
  @Input() showCustomDatePicker: boolean = false;
  @Input() selectionMode: 'single' | 'range' = 'range';

  /** Configurable title - defaults based on selection mode */
  @Input() title: string = '';

  /** Calendar settings */
  @Input() yearRange: string = '2000:2030';
  @Input() today: Date = new Date();
  @Input() showButtonBar: boolean = true;
  @Input() maxDate: Date | null = null;
  @Input() minDate: Date | null = null;
  @Input() allowFutureDates: boolean = false;

  /** Two-way binding property */
  @Input() customDateRange: Date | Date[] | null = null;
  @Output() customDateRangeChange = new EventEmitter<Date | Date[] | null>();

  /** Events */
  @Output() apply = new EventEmitter<Date[]>();
  @Output() cancel = new EventEmitter<void>();

  /** Get the display title based on selection mode or custom title */
  get displayTitle(): string {
    if (this.title) return this.title;
    return this.selectionMode === 'single' ? 'Select Date' : 'Select Date Range';
  }

  onCustomDateSelect() {
    this.customDateRangeChange.emit(this.customDateRange);
  }

  applyCustomDateRange() {
    const selected = this.customDateRange;
    if (!selected) {
      this.apply.emit([]);
      return;
    }

    if (this.selectionMode === 'single') {
      const date = Array.isArray(selected) ? selected[0] : selected;
      this.apply.emit(date ? [date] : []);
      return;
    }

    this.apply.emit(Array.isArray(selected) ? selected : [selected]);
  }

  cancelCustomDateRange() {
    this.cancel.emit();
  }
}
